import { JsonConverter, JsonCustomConvert } from 'json2typescript';

@JsonConverter
export class BooleanInverterAdapter implements JsonCustomConvert<boolean | undefined> {
    serialize(value: boolean): boolean {
        return value !== undefined ? !value : undefined;
    }

    deserialize(value: boolean): boolean {
        return typeof value === 'boolean' ? !value : undefined;
    }
}
